import { render } from "./Explore.vue?vue&type=template&id=512c2c07&scoped=true"
import script from "./Explore.vue?vue&type=script&lang=js"
export * from "./Explore.vue?vue&type=script&lang=js"

import "./Explore.vue?vue&type=style&index=0&id=512c2c07&scoped=true&lang=scss"

import exportComponent from "/var/lib/buildkite-agent/builds/assemble-builder/assemble-sports/broome-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-512c2c07"]])

export default __exports__